import { ApexOptions } from 'apexcharts'
import ReactApexChart from 'react-apexcharts'
import { useTranslation } from 'react-i18next'

import { getPieOptionsAndDataV2 } from './dataConverter'
import { ChartData } from '@/Atomic/Organisms/Charts/acBar/dataConverter'
import '../ChartError.scss'
import '../Charts.scss'

interface Param {
  salesData: ChartData | undefined
  showLegend: boolean
}

export function AcPieChart({
  salesData = undefined,
  showLegend = false,
}: Param) {
  const { t } = useTranslation()

  if (!salesData) {
    return <div></div>
  }

  let options
  let data

  try {
    const result = getPieOptionsAndDataV2(salesData, showLegend)
    options = result.options
    data = result.data
  } catch (error) {
    console.error(
      'Error processing pie chart data:',
      error instanceof Error ? error.message : 'Unknown error',
    )
    return (
      <div className="chart-error">
        {t('components.dashboard.chart.unableToRender')}
      </div>
    )
  }

  return (
    <div className="AcPieChart">
      <ReactApexChart
        options={options as ApexOptions}
        series={data}
        type={options.chart.type as 'pie'}
        width="100%"
        height="100%"
      />
    </div>
  )
}
